import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'antd';

export type ActionHandler<T> = (row: T) => void

type ActionButtonProps<T> = {
  className?: string,
  row: T,
  tooltip?: string,
  onClick: ActionHandler<T>,
  // Icon: (props: React.ComponentProps<'svg'>) => JSX.Element
  Icon: (props: any) => any
  danger?: boolean,
  padding?: boolean
};

const ActionButton: React.FC<ActionButtonProps<any>> = ({ className, row, tooltip, onClick, Icon, danger = false, padding = true }) => (
  <Tooltip title={tooltip}>
    <button onClick={(event) => {
      event.preventDefault()
      event.stopPropagation()
      onClick(row)
    }}
      className={classNames("inline-block",
        className, 
        {
          "px-3": padding,
          "text-gray-400 hover:text-gray-500": !danger,
          "text-red-400 hover:text-red-500": danger
        })}>
      <Icon className="h-4 w-4" />
    </button>
  </Tooltip>
);

export default ActionButton;
